import React, { useState } from 'react';
import { Form, Input, Button, message, Card } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../services/api';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
`;

const ResetCard = styled(Card)`
  width: 400px;
`;

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const token = searchParams.get('token');

  const handleSubmit = async (values: any) => {
    if (!token) {
      message.error('无效的重置链接');
      return;
    }

    try {
      setLoading(true);
      await auth.resetPassword(token, values.password);
      message.success('密码重置成功，请登录');
      navigate('/auth');
    } catch (error: any) {
      message.error(error.response?.data?.detail || '重置失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <ResetCard title="重置密码">
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="password"
            label="新密码"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, message: '密码至少6个字符' }
            ]}
          >
            <Input.Password placeholder="请输入新密码" />
          </Form.Item>
          
          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            dependencies={['password']}
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="请再次输入新密码" />
          </Form.Item>
          
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              重置密码
            </Button>
          </Form.Item>
        </Form>
      </ResetCard>
    </PageContainer>
  );
};

export default ResetPassword; 